import React, { Component } from 'react'
import includes from 'lodash/includes'
import get from 'lodash/get'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import PropTypes from 'prop-types'
import Rodal from 'rodal'
import DOMPurify from 'dompurify'
import domainUtils from '../../../../utils/routing/domain'
import * as feedDuck from '../feedDuck'

class FeedItemModalDisplay extends Component {
  static propTypes = {
    closeModal: PropTypes.func.isRequired,
    isShowingModal: PropTypes.bool.isRequired,
    selectedFeedItem: PropTypes.any,
  }

  render() {
    const { isShowingModal, closeModal, selectedFeedItem } = this.props

    return (
      <Rodal
        visible={isShowingModal}
        measure="%"
        height={90}
        width={90}
        customMaskStyles={{ opacity: 0.8 }}
        customStyles={{
          maxWidth: 700,
          backgroundColor: 'transparent',
          boxShadow: 'none',
        }}
        closeOnEsc
        onClose={closeModal}
        duration={200}
      >
        {selectedFeedItem && (
          <div
            style={{
              maxWidth: 700,
              margin: '-15px -15px 15px',
              overflowY: 'auto',
              borderRadius: '0.25rem',
              maxHeight: '100%',
              backgroundColor: 'white',
              opacity: 1,
              boxShadow: '0 1px 3px rgba(0, 0, 0, .2)',
            }}
          >
            <div className="p-3">
              <h4 style={{ marginRight: 20 }}>{selectedFeedItem.post_title}</h4>
              <h5
                dangerouslySetInnerHTML={{
                  __html: DOMPurify.sanitize(selectedFeedItem.post_description),
                }}
              />
            </div>
            <div>
              <div>
                {includes(get(selectedFeedItem, 'source_code'), 'youtube') && (
                  <div className="embed-responsive embed-responsive-16by9">
                    <iframe
                      className="embed-responsive-item"
                      src={selectedFeedItem.source_code.replace(
                        'watch?v=',
                        'embed/',
                      )}
                      title="feedVideo"
                    />
                  </div>
                )}
                {!includes(get(selectedFeedItem, 'source_code'), 'youtube') && (
                  <a
                    href={selectedFeedItem.source_url}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <img
                      style={{ width: '100%' }}
                      src={selectedFeedItem.source_code}
                      alt=""
                    />
                  </a>
                )}
              </div>
            </div>
            {selectedFeedItem.source_url && selectedFeedItem.credit_person && (
              <div className="p-3">
                <a
                  href={selectedFeedItem.source_url}
                  className="p-2"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i className="fal fa-external-link" /> Visit Site
                </a>
                <div
                  className="pull-right pr-2s"
                  style={{
                    fontSize: 10,
                    color: 'lightgray',
                    textAlign: 'right',
                  }}
                >
                  {selectedFeedItem.credit_person}
                  <br />
                  {domainUtils.rootDomain(selectedFeedItem.source_url)}
                </div>
              </div>
            )}
          </div>
        )}
      </Rodal>
    )
  }
}

const mapStateToProps = (state) => ({
  isShowingModal: state.feed.isShowingModal,
  selectedFeedItem: state.feed.selectedFeedItem,
})

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      closeModal: feedDuck.closeModal,
    },
    dispatch,
  )

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(FeedItemModalDisplay)



// WEBPACK FOOTER //
// ./src/routes/authenticated/Dashboard/components/FeedItemModalDisplay.js